import { Form, Formik } from 'formik';
import { FC } from 'react';

import { CheckoutDescription } from 'src/checkout/components/CheckoutDescription/CheckoutDescription';
import { FinanceResidentialStatusFields } from 'src/checkout/components/FinanceResidentialStatusFields/FinanceResidentialStatusFieldsLegacy';
import { FINANCE_FAMILY_STATUS, FINANCE_RESIDENTIAL_STATUS } from 'src/data/FinanceApi/FinanceApi.types';
import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { Button } from 'src/general/components/Button/Button';
import {
  FormikInputAddressAutocomplete,
  defaultValueInputAddressAutocomplete,
} from 'src/general/components/forms/FormikInputAddressAutocomplete/FormikInputAddressAutocomplete';
import { InputSelectFormik } from 'src/general/components/forms/Input/InputSelectFormik';
import { getMicrocopy } from 'src/stores/microcopyStore';

import styles from './PersonalizedQuoteForm.module.scss';
import {
  FamilyResidentialFormValidation,
  FamilyResidentialFormValues,
  PersonalizedQuoteFormProps,
  familyStatusOptions,
} from './PersonalizedQuoteForm.type';

const initialValues: FamilyResidentialFormValues = {
  familyStatus: '' as FINANCE_FAMILY_STATUS,
  address: { ...defaultValueInputAddressAutocomplete },
  residentialStatus: '' as FINANCE_RESIDENTIAL_STATUS,
  currentAddressStartDate: '',
  hasTenancyAgreement: '',
  hasMortgageOnCurrentAddress: '',
  hasInvestmentProperty: '',
  hasMortgageOnInvestmentProperty: '',
  investmentPropertyAddress: { ...defaultValueInputAddressAutocomplete },
  previousResidentialAddress: { ...defaultValueInputAddressAutocomplete },
  previousAddressStartDate: '' as any,
  isBusinessUseSelected: false,
};

export const FamilyResidentialForm: FC<PersonalizedQuoteFormProps<FamilyResidentialFormValues>> = ({
  onBack,
  onSubmit,
  values,
}) => (
  <>
    <CheckoutDescription
      title={
        values.isBusinessUseSelected
          ? getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_FAMILY_RESIDENTIAL_RESIDENTIAL_ADDRESS_TITLE)
          : getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_FAMILY_RESIDENTIAL_FORM_HEADER)
      }
      onBack={onBack}
    />
    <div className={styles.familyResidential}>
      <Formik
        initialValues={{ ...initialValues, ...values }}
        onSubmit={onSubmit}
        validationSchema={FamilyResidentialFormValidation}
      >
        {(props) => (
          <Form className={styles.form}>
            {!values.isBusinessUseSelected && (
              <>
                <p className={styles.familyResidentialTitle}>
                  {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_FAMILY_RESIDENTIAL_FAMILY_STATUS_TITLE)}
                </p>
                <div className={styles.familyStatusContainer}>
                  <InputSelectFormik
                    name="familyStatus"
                    id="familyStatus"
                    label="Family status"
                    data-testid="family-status"
                    options={familyStatusOptions.map((item) => ({
                      value: item.value,
                      label: getMicrocopy(item.label),
                    }))}
                    allowEmpty
                  />
                </div>

                <p className={styles.familyResidentialTitle}>
                  {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_FAMILY_RESIDENTIAL_RESIDENTIAL_ADDRESS_TITLE)}
                </p>
              </>
            )}
            <FormikInputAddressAutocomplete name="address" {...props} data-testid="buyer-street-address" />

            <FinanceResidentialStatusFields
              formikProps={props}
              isBusinessFinanceApplication={values.isBusinessUseSelected ?? false}
            />

            <footer className={styles.familyResidentialButtonContainer}>
              <Button type="submit" isLoading={props.isSubmitting} fullWidth data-testid="submit">
                {values.isBusinessUseSelected
                  ? getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_FAMILY_RESIDENTIAL_BUSINESS_BUTTON_SUBMIT)
                  : getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_FAMILY_RESIDENTIAL_PERSONAL_BUTTON_SUBMIT)}
              </Button>
            </footer>
          </Form>
        )}
      </Formik>
    </div>
  </>
);
